import { CETopicBase } from './ce-topic-base'


export class CETopic extends CETopicBase {

}